import Vue from 'vue';
import WhiteLabelContent from '@/plugins/graphql/queries/v2/white-label-content.gql';
export default Vue.extend({
    apollo: {
        whiteLabelContent: {
            query: WhiteLabelContent,
            variables() {
                return {
                    origin: this.getOrigin,
                };
            },
            update(data) {
                return data.whiteLabelContent;
            },
        },
    },
    data() {
        return {
            whiteLabelContent: null,
        };
    },
    computed: {
        getOrigin() {
            const { origin } = window.location;
            return origin.replace(/^https?:\/\//i, '');
        },
    },
    render() {
        if (this.$scopedSlots.default) {
            return this.$scopedSlots.default({
                whiteLabelContent: this.whiteLabelContent,
            });
        }
    },
});
